/**
 * Created by roman.kupin on 7/27/2017.
 */

/*export*/ class Contacts {
    static names = {
        'alfredo': 'Alfredo',
        'brandon': 'Brandon',
        'chris': 'Chris',
        'danielle': 'Danielle',
        'david': 'David',
        'debi': 'Debi',
        'diane': 'Diane',
        'ed': 'Ed',
        'geetha': 'Geetha',
        'gisele': 'Gisele',
        'guido': 'Guido',
        'hal': 'Hal',
        'jeanmichel': 'Jean-Michel',
        'jeff': 'Jeff',
        'jessica': 'Jessica',
        'jon': 'Jon',
        'joseph': 'Joseph',
        'matt': 'Matt',
        'mike': 'Michael',
        'monica': 'Monica',
        'raul': 'Raul',
        'richard': 'Richard',
        'loren': 'Loren',
        'richardtoms': 'Richard',
        'shelby': 'Shelby',
        'worldhotels': 'Daniel',
        'stashrewards': 'Richard',
        'milemarker630': 'Allison'
    };
    static emails = {
        'alfredo': 'join@flip.to',
        'brandon': 'join@flip.to',
        'chris': 'join@flip.to',
        'danielle': 'join@flip.to',
        'david': 'join@flip.to',
        'debi': 'join@flip.to',
        'diane': 'dvanleunen@flip.to',
        'ed': 'estonge@flip.to',
        'geetha': 'join@flip.to',
        'gisele': 'gsuarez@flip.to',
        'guido': 'gsalvatori@flip.to',
        'hal': 'hfickett@flip.to',
        'jeanmichel': 'jmrepellin@flip.to',
        'jeff': 'join@flip.to',
        'jessica': 'jaslanian@flip.to',
        'jon': 'jruggles@flip.to',
        'joseph': 'jmeuse@flip.to',
        'matt': 'join@flip.to',
        'mike': 'mmathews@flip.to',
        'monica': 'mrodino@flip.to',
        'raul': 'join@flip.to',
        'richard': 'join@flip.to',
        'loren': 'loreneegray@gmail.com',
        'richardtoms': 'richard@thebrandmix.com',
        'shelby': 'marketing@flip.to',
        'worldhotels': 'dspellman@worldhotels.com',
        'stashrewards': 'join@flip.to',
        'milemarker630': 'allison@milemarker630.com'
    };
    static emailsToShortNames = {
        'alfredo@flip.to': 'alfredo',
        'barbelaez@flip.to': 'brandon',
        'dfierman@flip.to': 'danielle',
        'dbruce@flip.to': 'david',
        'dmoses@flip.to': 'debi',
        'dvanleunen@flip.to': 'diane',
        'estonge@flip.to': 'ed',
        'gbalakrishnan@flip.to': 'geetha',
        'gsuarez@flip.to': 'gisele',
        'gsalvatori@flip.to': 'guido',
        'hfickett@flip.to': 'hal',
        'jmrepellin@flip.to': 'jeanmichel',
        'jweibel@flip.to': 'jeff',
        'jaslanian@flip.to': 'jessica',
        'jruggles@flip.to': 'jon',
        'jmeuse@flip.to': 'joseph',
        'mcaverly@flip.to': 'matt',
        'mmathews@flip.to': 'mike',
        'mrodino@flip.to': 'monica',
        'rvega@flip.to': 'raul',
        'rdunbar@flip.to': 'richard',
        'loreneegray@gmail.com': 'loren',
        'allison@milemarker630.com': 'milemarker630'
    };
}


angular.module("fliptoWeb")
    .constant("contacts", Contacts);

